import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { TranslationProvider } from './context/TranslationContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import OrderPage from './pages/OrderPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import FaqPage from './pages/FaqPage';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import DashboardHome from './pages/admin/DashboardHome';
import ProductListPage from './pages/admin/ProductListPage';
import PickupLocationListPage from './pages/admin/PickupLocationListPage';
import OrderListPage from './pages/admin/OrderListPage';
import FaqListPage from './pages/admin/FaqListPage';
import AdminUserListPage from './pages/admin/AdminUserListPage';
import ProfilePage from './pages/admin/ProfilePage';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <TranslationProvider>
        <AuthProvider>
          <CartProvider>
          <div className="app">
            <Routes>
              {/* Admin Routes */}
              <Route path="/admin/login" element={<LoginPage />} />
              
              {/* Protected Admin Routes */}
              <Route path="/admin" element={<ProtectedRoute />}>
                <Route path="/admin/dashboard" element={<DashboardPage />}>
                  <Route index element={<DashboardHome />} />
                  <Route path="products" element={<ProductListPage />} />
                  <Route path="pickup-locations" element={<PickupLocationListPage />} />
                  <Route path="orders" element={<OrderListPage />} />
                  <Route path="faqs" element={<FaqListPage />} />
                  <Route path="admin-users" element={<AdminUserListPage />} />
                  <Route path="profile" element={<ProfilePage />} />
                </Route>
              </Route>
              
              {/* Public Routes */}
              <Route
                path="/"
                element={
                  <>
                    <Header />
                    <main className="main-content">
                      <HomePage />
                    </main>
                    <Footer />
                  </>
                }
              />
              <Route
                path="/products"
                element={
                  <>
                    <Header />
                    <main className="main-content">
                      <ProductsPage />
                    </main>
                    <Footer />
                  </>
                }
              />
              <Route
                path="/order"
                element={
                  <>
                    <Header />
                    <main className="main-content">
                      <OrderPage />
                    </main>
                    <Footer />
                  </>
                }
              />
              <Route
                path="/order-confirmation"
                element={
                  <>
                    <Header />
                    <main className="main-content">
                      <OrderConfirmationPage />
                    </main>
                    <Footer />
                  </>
                }
              />
              <Route
                path="/faqs"
                element={
                  <>
                    <Header />
                    <main className="main-content">
                      <FaqPage />
                    </main>
                    <Footer />
                  </>
                }
              />
            </Routes>
          </div>
        </CartProvider>
        </AuthProvider>
      </TranslationProvider>
    </Router>
  );
};

export default App;
